import React from 'react';
import { useAuthError } from '../hooks/useAuthError';
import AuthErrorDialog from './Dialogs/AuthErrorDialog';

export const AuthErrorContext = React.createContext<{
  handleAuthError: () => void;
}>({ handleAuthError: () => {} });

export const AuthErrorProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const { showAuthError, handleAuthError, handleReload, handleLogin, handleDismiss } = useAuthError();

  const wrappedHandler = () => {
    handleAuthError();
  };

  return (
    <AuthErrorContext.Provider value={{ handleAuthError: wrappedHandler }}>
      {children}
      <AuthErrorDialog isOpen={showAuthError} onDismiss={handleDismiss} onReload={handleReload} onLogin={handleLogin} />
    </AuthErrorContext.Provider>
  );
};

// Custom hook to use the auth error context
export const useAuthErrorContext = () => {
  const context = React.useContext(AuthErrorContext);
  if (!context) {
    throw new Error('useAuthErrorContext must be used within an AuthErrorProvider');
  }
  return context;
};
